<template>
    <section class="section-hero section-shaped my-0 main-select">
        <div class="shape shape-style-1 shape-primary" style="background: linear-gradient(150deg, #63236d 15%, #873693 70%, #63236d 94%) !important;">
            <!--<span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>-->
        </div>

        <div class="container shape-container d-flex flex-column">

            <div class="mb-auto box-content-home">

                <div class="col px-0">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="head-titles">
                                <h2 class="mb-0 text-white font-raleway">RANKING DE</h2>
                                <h2 class="mb-0 text-white font-raleway"><span class="display-3">INVERSIÓN,</span> IGUALDAD Y</h2>
                                <h2 class="mb-0 text-white font-raleway">EQUIDAD DE GÉNERO</h2>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="light" style="background-image: url('img/maps/lights.png')"></div>
                            <div class="box-img-map">
                                <img src="/img/maps/bolivie.png" class="img-fluid floating" alt="" >
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            
            <div class="" style="padding:0px 0px 50px;background:">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-md-12">

                            <div class="pearls pearls-xs row">
                                <div class="pearl col-md-4 col-sm-12">
                                    
                                    <div class="pearl-title">
                                      
                                        <div class="select_custom">                                       
                                            <select id="selectType" class="cs-select cs-skin-slide">
                                                <option v-for="(type, index) in parameters.types" :value="type.type" data-class="fa fa-map-o">{{ type.name }}</option>
                                            </select>
                                        </div>
                                        <label class="select-label">Tipo de Región</label>

                                    </div>
                                </div>
                                <div class="pearl col-md-4 col-sm-12">
                                    
                                    <div class="pearl-title">

                                        <div class="select_custom">                                       
                                            <select id="selectCity" class="cs-select cs-skin-slide">

                                                <option v-for="(citie, index) in parameters.cities" :value="citie.id" data-class="fa fa-map-marker">{{ citie.name }}</option>   
                                                <!--<option value="0" selected data-class="fa fa-globe">Bolivia</option>
                                                <option value="1" data-class="fa fa-map-marker">La Paz</option>-->
                                            </select>
                                        </div>
                                        <label class="select-label">Departmento</label>
                                      
                                    </div>
                                </div>
                                <div class="pearl col-md-4 col-sm-12">
                                    
                                    <div class="pearl-title">
                                        
                                        <div class="select_custom">                                       
                                            <select id="selectYear" class="cs-select cs-skin-slide">
                                                <option v-for="(year, index) in parameters.years" :value="year.year" data-class="fa fa-calendar">{{ year.year }}</option>
                                            </select>
                                        </div>
                                        <label class="select-label">Gestión</label>

                                    </div>
                                </div>
                            </div>
                            
                            <div class="btn-wrapper text-center">
                                <a v-on:click="submitData" class="btn btn-primary btn-home-submit mb-3 mb-sm-0">Continuar</a>
                            </div>
    
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
const axios = require('axios');

export default {
    name: "home-investments",
    updated() {
        this.initSelect();
    },
    data() {
        return {
            parameters: '',

            type: '',
            year: '',
            city: '',
        }
    },
    mounted(){
        this.getGeneralData();
        
    },
    methods: {
        getGeneralData(){
          let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/initial/parameters`;

          axios.get(uri).then((response) => {
            this.parameters = response.data.result;             
            
          }).catch((response) => { 
              console.log(response) ;
          }).finally(() => {});
        },
        initSelect() {
            [].slice.call( document.querySelectorAll( '.cs-select' ) ).forEach( function(el) {    
                new SelectFx(el);
            } );
        },
        submitData() {
            let st = document.getElementById('selectType').value;
            let sc = document.getElementById('selectCity').value;
            let sc_txt = document.getElementById('selectCity').options[document.getElementById('selectCity').selectedIndex].text;
            sc_txt = this.slugify(sc_txt);
            let sy = document.getElementById('selectYear').value;
            if (st == 'municipalities') {
                if (sc == 0){
                    this.$router.push({name: 'investment.municipalities.national', params: {year: sy, city: sc}});
                } else {
                    this.$router.push({name: 'investment.municipalities' ,params: {year:sy, city:sc, name: sc_txt}});
                }
            } else if (st == 'governances') {
                this.$router.push({name: 'investment.governances' ,params: {year:sy, city:sc, name: sc_txt}});
            } else {
                console.log(st);
            }            
        },
        slugify(text)
        {
          return text.toString().toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '');
        }
    }
};
</script>
<style>
</style>
